// extracted by mini-css-extract-plugin
export var audioPlayer = "_sk-0";